import { GlobalBus } from '@services/bus'
import { MODAL, MODAL_IMPORT, RELOAD } from '@constants/Text'

export default {
  created() {
    GlobalBus.$on(RELOAD.CLIENT_CREATED, this.selectCreatedClient)
  },
  beforeDestroy() {
    GlobalBus.$off(RELOAD.CLIENT_CREATED, this.selectCreatedClient)
  },
  methods: {
    openSelectClientModal() {
      GlobalBus.$emit(MODAL.CONSOLIDATOR_SELECT_CLIENT)
    },
    openRegisterClientModal() {
      GlobalBus.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    openRegisterAssetModal() {
      GlobalBus.$emit(MODAL.CONSOLIDADOR_REGISTER_ASSET, { item: {} })
    },
    openImportExtratoModal() {
      GlobalBus.$emit(MODAL_IMPORT.EXTRATO_CLIENTES)
    },
    selectCreatedClient(client) {
      if (!client) return
      const createdId = client.id || client.id_cliente || client.id_cliente_app
      if (!createdId) return
      this.$store.dispatch('user/addSearchClient', {
        ...client,
        id: createdId,
        name: client.name || client.nome_cliente || '',
      })
      GlobalBus.$emit('changeClient')
    },
  },
}
